module.exports = __webpack_public_path__ + "assets/img/DS-living dinning (7).ead42b1b.jpg";